import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const ImmigrationNavbar = () => {
  const [hasScrolled, setHasScrolled] = useState(false);
  // Update navbar appearance based on scroll position
  useEffect(() => {
    const updateScrollState = () => {
      setHasScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', updateScrollState);
    updateScrollState(); // Initial check
    return () => window.removeEventListener('scroll', updateScrollState);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${hasScrolled ? 'backdrop-blur-md bg-white/90 shadow-[0_4px_30px_rgba(46,107,255,0.08)] border-b border-[#E7EAF0]/40' : 'backdrop-blur-sm bg-white/70 border-b border-[#E7EAF0]/20'}`} data-id="element-396">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-397">
        <div className="flex justify-between items-center h-16" data-id="element-398">
          {/* Logo and Brand */}
          <div className="flex items-center" data-id="element-399">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5
          }} className="flex-shrink-0" data-id="element-400">
              <a href="https://www.pigeonimmigration.com/" className="flex items-center" data-id="element-401">
                <img src="https://i.imgur.com/W2X0iTc.png" alt="Pigeon Logo" className="h-10 mr-2" data-id="element-402" />
                <span className="text-xl font-bold flex flex-col -space-y-2" style={{
                fontFamily: 'Helvetica, sans-serif'
              }} data-id="element-403">
                  <span style={{
                  color: '#1432f4'
                }} data-id="element-404">
                    Pigeon
                  </span>
                  <span style={{
                  color: '#000000'
                }} data-id="element-405">
                    Immigration
                  </span>
                </span>
              </a>
            </motion.div>
          </div>
          {/* CTA Button - Only showing Book a Call */}
          <div className="flex items-center" data-id="element-406">
            <motion.a href="https://calendly.com/pigeondocuments/15min" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-[#2E6BFF] to-[#36D1DC] hover:from-[#2059E2] hover:to-[#32C3CE] text-white px-6 py-3 rounded-full text-base font-medium transition-all duration-300 shadow-[0_4px_14px_rgba(46,107,255,0.25)] whitespace-nowrap" whileHover={{
            y: -1,
            scale: 1.02,
            boxShadow: '0 6px 20px rgba(46,107,255,0.35)'
          }} whileTap={{
            scale: 0.98
          }} data-id="element-407">
              Book a Call
            </motion.a>
          </div>
        </div>
      </div>
    </nav>;
};